export default __webpack_public_path__ + "static/media/campfire_tablet.a74374f6.svg";